import type { FundStatementPeriodViewModel } from '../../../hooks/useFundStatementPeriodSection';
import { FundAccountList } from './FundAccountList';
import { FundAccountStatementCard } from './FundAccountStatementCard';
import { PeriodHeader } from './PeriodHeader';
import { RollUpStatementCard } from './RollUpStatementCard';

export function FundStatementPeriodView({ header, rollUp, fundAccounts, card }: FundStatementPeriodViewModel) {
    return (
        <div className="space-y-6">
            <PeriodHeader {...header} />
            <RollUpStatementCard {...rollUp} />
            {rollUp.state === 'ok' && (
                <div className="grid gap-6 lg:grid-cols-2">
                    <FundAccountList {...fundAccounts} />
                    <FundAccountStatementCard {...card} />
                </div>
            )}
        </div>
    );
}
